import * as React from 'react';

function SvgEmojiFrownFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 16A8 8 0 108 0a8 8 0 000 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-2.715 5.933a.5.5 0 01-.183-.683A4.498 4.498 0 018 9.5a4.5 4.5 0 013.898 2.25.5.5 0 01-.866.5A3.498 3.498 0 008 10.5a3.498 3.498 0 00-3.032 1.75.5.5 0 01-.683.183zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z' />
		</svg>
	);
}

export default SvgEmojiFrownFill;
